export default [
    {
        path: '/empty-out-picking-cart/show',
        name: 'empty-out-picking-cart_show',
        component: () => import('@src/empty-out-picking-cart/empty-out-picking-cart-show.vue'),
        meta: {
            title: 'Pickwagen verräumen',
            role: 'ROLE_EMPTY_OUT_PICKING_CART',
        },
    },
];
